import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'src/app/services/security.service';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.scss']
})
export class EsqueciSenhaComponent implements OnInit {

  esqueciForm: FormGroup
  mensagem;
  enviado;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private securityService: SecurityService
  ) { }

  ngOnInit(): void {
    this.esqueciForm = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  async submit() {
    if (this.esqueciForm.valid) {
      this.spinner.show();
      try {
        const result = await this.securityService.resetarSenha(this.esqueciForm.get('email').value);
        this.mensagem = "Foi enviado um e-mail com um link para que você possa resetar sua senha.";
        this.enviado = true;
        this.spinner.hide();
      } catch (err) {
        this.mensagem = err.message;
        console.log(err);
        this.spinner.hide();
      }
    } else {
      this.mensagem = 'Favor preencher os cammpos';
    }
  }

}
